<template>
  <b-modal
    id="vote-list-modal"
    size="xl"
    hide-footer
  >
    <b-row v-if="isQuestionDate">
      <!-- Search -->
      <b-col
        cols="12"
        md="12"
      >
        <h3 class="d-flex justify-content-center mb-0">
          {{ getListTitle }}
        </h3>
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="12">
        <b-table
          :items="items"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          :empty-text="$t('no_matching_records')"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <!-- Column: fullName -->
          <template #cell(fullName)="{ value }">
            <b-avatar
              variant="light-primary"
              :text="getInitials(value)"
            />
            <b-link
              class="ml-1 text-capitalize"
            >
              {{ value }}
            </b-link>
          </template>

          <!-- Column: startDate -->
          <template
            v-if="isQuestionRange"
            #cell(startDate)="{ item }"
          >
            {{ item.startingDay.toDate().toLocaleDateString('fi') }}
          </template>

          <!-- Column: endDate -->
          <template
            v-if="isQuestionRange"
            #cell(endDate)="{ item }"
          >
            {{ item.endingDay.toDate().toLocaleDateString('fi') }}
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="{ }">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.hwUiLayout.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item>
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">Details</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-row>
      <b-col
        cols="12"
        class="d-flex justify-content-between align-items-center"
      >
        <span class="text-nowrap">
          Showing {{ perPage*(currentPage-1)+ 1 }} to {{ perPage*currentPage > users.length ? users.length : perPage*currentPage }} of {{ users.length }} items
        </span>

        <b-pagination
          v-model="currentPage"
          hide-goto-end-buttons
          hide-ellipsis
          :per-page="perPage"
          :limit="7"
          :total-rows="users.length"
          class="mb-1"
        />
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import {
  BModal, BRow, BCol, BTable,
  BDropdown, BDropdownItem, BAvatar, BLink, BPagination,
} from 'bootstrap-vue'
import { getInitials } from '@hw-core/utils'
import { TYPES } from '@/shared/constants'
import moment from 'moment'

export default {
  components: {
    BModal,
    BRow,
    BCol,
    // BFormSelect,
    BTable,
    BDropdown,
    BDropdownItem,
    BAvatar,
    BLink,
    BPagination,
  },
  props: {
    users: {
      type: Array,
      default: () => [],
    },
    questionType: {
      type: String,
      default: '',
    },
    listTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      sortBy: 'name',
      sortDesc: false,
      perPage: 20,
      currentPage: 1,
    }
  },
  computed: {
    items() {
      return this.users.slice(this.perPage * (this.currentPage - 1), this.perPage * this.currentPage)
    },
    isQuestionDate() {
      return this.questionType === TYPES.DATE
    },
    isQuestionRange() {
      return this.questionType === TYPES.RANGE
    },
    getListTitle() {
      if (this.listTitle && this.listTitle.length) {
        return moment(this.listTitle).format('DD/MM/YYYY')
      }
      return ''
    },
    tableColumns() {
      if (this.isquestionDate) {
        return [
          {
            key: 'fullName',
            label: this.$t('questionnaire.name'),
            sortable: true,
            style: {
              width: '300px',
              maxWidth: '300px',
            },
          },
          {
            key: 'email',
            label: this.$t('questionnaire.email'),
            sortable: true,
          },
          {
            key: 'mobile',
            label: this.$t('questionnaire.phone'),
            sortable: true,
          },
          {
            key: 'role',
            label: this.$t('questionnaire.role'),
            sortable: true,
            class: 'text-capitalize',
          },
        ]
      }

      if (this.isQuestionRange) {
        return [
          {
            key: 'fullName',
            label: this.$t('questionnaire.name'),
            sortable: true,
            style: {
              width: '300px',
              maxWidth: '300px',
            },
          },
          {
            key: 'startDate',
            label: this.$t('questionnaire.startDate'),
            sortable: true,
          },
          {
            key: 'endDate',
            label: this.$t('questionnaire.endDate'),
            sortable: true,
          },
          {
            key: 'email',
            label: this.$t('questionnaire.email'),
            sortable: true,
          },
          {
            key: 'mobile',
            label: this.$t('questionnaire.phone'),
            sortable: true,
          },
          {
            key: 'role',
            label: this.$t('questionnaire.role'),
            sortable: true,
            class: 'text-capitalize',
          },
        ]
      }

      return [
        {
          key: 'fullName',
          label: this.$t('questionnaire.name'),
          sortable: true,
          style: {
            width: '300px',
            maxWidth: '300px',
          },
        },
        {
          key: 'email',
          label: this.$t('questionnaire.email'),
          sortable: true,
        },
        {
          key: 'mobile',
          label: this.$t('questionnaire.phone'),
          sortable: true,
        },
        {
          key: 'role',
          label: this.$t('questionnaire.role'),
          sortable: true,
          class: 'text-capitalize',
        },
        {
          key: 'actions',
          label: this.$t('questionnaire.actions'),
          style: {
            width: '80px',
            maxWidth: '80px',
          },
        },
      ]
    },
  },
  methods: {
    getInitials,
  },
}
</script>

<style></style>
